module.exports = __webpack_public_path__ + "img/so.4e89794d.jpg";